import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, ArrowRight, Newspaper, Filter, CheckCircle, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const News = () => {
  const allNews = [
    {
      id: 1,
      title: 'Nouvelles Réglementations ANJ 2025 : Ce Qui Change pour les Parieurs',
      date: '25.11.2025',
      excerpt: 'L\'Autorité Nationale des Jeux annonce de nouvelles mesures de protection des joueurs et des modifications importantes dans les conditions de bonus.',
      link: '/news/nouvelles-reglementations-anj-2025',
    },
    {
      id: 2,
      title: 'Comparatif des Meilleurs Bonus de Bienvenue : Notre Analyse 2025',
      date: '24.11.2025',
      excerpt: 'Nous avons analysé en détail les offres promotionnelles des principales plateformes pour vous aider à choisir le bonus le plus avantageux.',
      link: '/news/comparatif-bonus-bienvenue-2025',
    },
    {
      id: 3,
      title: 'Tendances des Paris Sportifs en France : Football et Tennis en Tête',
      date: '23.11.2025',
      excerpt: 'Analyse des habitudes de paris des Français en 2025. Le football reste le sport le plus parié, suivi de près par le tennis et les courses hippiques.',
      link: '/news/tendances-paris-sportifs-2025',
    },
    {
      id: 4,
      title: 'Nouveaux Opérateurs sur le Marché Français : Opportunités et Risques',
      date: '22.11.2025',
      excerpt: 'Plusieurs nouveaux opérateurs agréés ont rejoint le marché français cette année. Analyse de leurs offres, leurs forces et les points d\'attention pour les parieurs.',
      link: '/news/nouveaux-operateurs-marche-francais',
    },
    {
      id: 5,
      title: 'L\'Impact du Live Betting sur les Habitudes de Paris',
      date: '21.11.2025',
      excerpt: 'Le pari en direct représente désormais plus de 40% des mises totales. Comment cette évolution change-t-elle les stratégies et les comportements des parieurs ?',
      link: '/news/impact-live-betting-habitudes-paris',
    },
    {
      id: 6,
      title: 'Protection des Joueurs : Les Nouvelles Mesures ANJ',
      date: '20.11.2025',
      excerpt: 'L\'Autorité Nationale des Jeux renforce ses dispositifs de protection avec de nouveaux outils d\'auto-exclusion et des limites de dépôt plus strictes.',
      link: '/news/protection-joueurs-nouvelles-mesures-anj',
    },
    {
      id: 7,
      title: 'Évolution des Cotes : Analyse Comparative 2024-2025',
      date: '19.11.2025',
      excerpt: 'Notre étude révèle des changements significatifs dans les cotes proposées par les principales plateformes. Quelles sont les meilleures valeurs actuellement ?',
      link: '/news/evolution-cotes-analyse-comparative',
    },
    {
      id: 8,
      title: 'Les Paris Hippiques à l\'Ère Numérique : Innovations et Tendances',
      date: '18.11.2025',
      excerpt: 'Les plateformes de paris hippiques innovent avec de nouveaux outils d\'analyse, des statistiques avancées et des expériences de pari améliorées.',
      link: '/news/paris-hippiques-ere-numerique',
    },
    {
      id: 9,
      title: 'Méthodes de Paiement : Quoi de Neuf en 2025 ?',
      date: '17.11.2025',
      excerpt: 'Les options de dépôt et de retrait évoluent. Cryptomonnaies, portefeuilles électroniques, nouvelles cartes : tour d\'horizon des innovations disponibles.',
      link: '/news/methodes-paiement-2025',
    },
  ];

  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <Newspaper className="w-16 h-16 text-toxic-green" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Actualités & <span className="text-toxic-green">Analyses</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Restez informé des dernières tendances, réglementations et évolutions du marché des paris en ligne en France
            </p>
          </div>

          {/* News Cards Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {allNews.map((item, index) => (
              <article
                key={item.id}
                itemScope
                itemType="http://schema.org/NewsArticle"
                className="bg-dark-card border-2 border-gray-800 rounded-2xl overflow-hidden hover:border-toxic-green transition-all transform hover:scale-105 group"
              >
                <Link
                  to={item.link}
                  data-discover="true"
                  itemProp="url"
                  className="block"
                >
                  {/* News image */}
                  <div className="h-48 relative overflow-hidden">
                    <img 
                      src={`/images/${[
                        'robert-katzki-APZWYETwgp0-unsplash.webp',
                        'max-titov-xtRWIviknsw-unsplash.webp',
                        'waldemar-brandt-iiwYpGkbDgM-unsplash.webp',
                        'ammar-el-attar-pXEzBYfvooM-unsplash.webp',
                        'andres-rebollar-F8MWGEzQ3xk-unsplash.webp',
                        'eduard-labar-9lOrwiZ3W4k-unsplash.webp',
                        'giero-saaski-HPus1oCcOdk-unsplash.webp',
                        'gonzalo-facello-RjCo6j0BkU8-unsplash.webp',
                        'kathrine-heigan-TF72aeJU0gc-unsplash.webp'
                      ][index]}`}
                      alt={item.title}
                      itemProp="image"
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-transparent to-transparent"></div>
                    <div className="absolute top-4 left-4 z-10">
                      <div className="flex items-center text-sm text-gray-300 bg-dark-bg/80 px-3 py-1 rounded-full">
                        <Calendar className="w-4 h-4 mr-2 text-toxic-green" />
                        <time dateTime={item.date.split('.').reverse().join('-')} itemProp="datePublished">{item.date}</time>
                      </div>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-3 text-white group-hover:text-toxic-green transition-colors line-clamp-2" itemProp="headline">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 mb-4 leading-relaxed line-clamp-3" itemProp="description">
                      {item.excerpt}
                    </p>
                    <div className="inline-flex items-center text-toxic-green font-semibold group-hover:text-opacity-80 transition-colors">
                      Lire la suite
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {/* How We Choose News Section */}
          <div className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 border-2 border-toxic-green opacity-10 rotate-45 transform translate-x-20 -translate-y-20"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 border-2 border-toxic-green opacity-10 rotate-45 transform -translate-x-16 translate-y-16"></div>
            
            <div className="relative z-10">
              <div className="flex items-center mb-6">
                <Filter className="w-8 h-8 text-toxic-green mr-4" />
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Comment Nous Choisissons Nos Actualités
                </h2>
              </div>

              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  Dans un secteur en constante évolution comme celui des paris en ligne, l'information est abondante, mais toutes les informations ne se valent pas. Chez Hexabet Connect, nous ne publions pas toutes les actualités qui nous parviennent. Nous appliquons une sélection rigoureuse basée sur des critères précis qui garantissent que chaque article que vous lisez apporte une réelle valeur.
                </p>

                <p>
                  Notre premier critère est la pertinence pour les parieurs français. Nous ne nous intéressons qu'aux actualités qui ont un impact direct ou indirect sur votre expérience de paris. Les nouvelles réglementations de l'ANJ, les changements dans les offres promotionnelles, les évolutions des plateformes, les tendances du marché - tout ce qui peut influencer vos décisions ou améliorer votre compréhension du secteur trouve sa place. Les rumeurs, les spéculations non fondées, ou les actualités qui n'ont aucun impact pratique sont systématiquement écartées.
                </p>

                <p>
                  La vérification des sources est fondamentale. Chaque information que nous publions provient de sources fiables et vérifiables : communiqués officiels de l'ANJ, annonces des plateformes agréées, données statistiques officielles, analyses d'experts reconnus. Nous ne relayons jamais d'informations de seconde main non vérifiées, et nous distinguons toujours clairement les faits établis des analyses ou opinions. Si une information n'est pas confirmée, nous le précisons explicitement.
                </p>

                <p>
                  L'actualité et la nouveauté sont aussi importantes. Nous privilégions les informations récentes qui apportent quelque chose de nouveau. Une simple répétition d'une actualité déjà largement couverte n'a pas d'intérêt, sauf si nous apportons une analyse approfondie ou un angle nouveau. Nous suivons quotidiennement les évolutions du secteur pour être parmi les premiers à vous informer des changements significatifs.
                </p>

                <p>
                  L'utilité pratique est un critère déterminant. Chaque actualité que nous choisissons doit pouvoir vous aider d'une manière ou d'une autre : comprendre une nouvelle réglementation pour adapter votre stratégie, identifier une nouvelle opportunité de bonus, comprendre une tendance pour améliorer vos paris, ou simplement rester informé des évolutions du marché. Si une actualité n'apporte aucune valeur pratique, elle ne mérite pas d'être publiée.
                </p>

                <p>
                  Nous privilégions aussi la profondeur à la surface. Plutôt que de simplement relayer une information, nous l'analysons, l'expliquons, et la mettons en contexte. Une nouvelle réglementation n'est pas juste annoncée - nous expliquons ce qu'elle change concrètement pour vous, comment elle affecte les plateformes, quelles sont les implications pratiques. Cette approche demande plus de temps et d'effort, mais elle garantit que vous comprenez vraiment les enjeux.
                </p>

                <p>
                  L'objectivité est non négociable. Même si nous pouvons recevoir des commissions via des liens d'affiliation, cela n'influence jamais notre sélection ou notre traitement des actualités. Si une plateforme annonce une nouvelle offre, nous la présentons objectivement, en mentionnant aussi bien les avantages que les limitations. Si une réglementation est controversée, nous présentons les différents points de vue. Notre crédibilité dépend de notre objectivité.
                </p>

                <p>
                  Enfin, nous privilégions la qualité à la quantité. Mieux vaut publier moins d'articles mais des articles approfondis et utiles, que de saturer nos lecteurs avec des actualités superficielles. Chaque article que nous publions a été soigneusement rédigé, vérifié, et structuré pour être aussi informatif et utile que possible.
                </p>

                <div className="grid md:grid-cols-3 gap-6 mt-8">
                  <div className="flex items-start space-x-3">
                    <CheckCircle className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Sources Vérifiées</h3>
                      <p className="text-sm text-gray-400">Toutes nos informations proviennent de sources fiables et officielles</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <TrendingUp className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Pertinence Pratique</h3>
                      <p className="text-sm text-gray-400">Chaque actualité doit apporter une valeur réelle aux parieurs</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Filter className="w-6 h-6 text-toxic-green flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-white mb-1">Sélection Rigoureuse</h3>
                      <p className="text-sm text-gray-400">Nous privilégions la qualité et la profondeur à la quantité</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default News;

